// extracted by mini-css-extract-plugin
export default {"listTitle":"Pg_3_11_listTitle__UiVMI","line":"Pg_3_11_line__cJ3lo"};